import * as React from 'react';
export const linkSvg = React.forwardRef(function linkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00D66F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#011E0F',
      d: 'M15.144 6H10c1 4.18 3.923 7.753 7.58 10C13.917 18.246 11 21.82 10 26h5.144c1.275-3.867 4.805-7.227 9.142-7.914v-4.18c-4.344-.68-7.874-4.04-9.142-7.906Z',
    }),
  );
});
linkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var link = {
  category: 'brand',
  colorable: false,
  name: 'link',
  svg: linkSvg,
};
